import type { FC, Ref } from 'react';
import { getAccessibleTabIndex } from '../Button/ariaHelpers';
import { getRadioClassNames } from './Radio.styles';
import { type RadioProps, fromValueToState } from './Radio.types';

export const Radio: FC<RadioProps> = ({
  value,
  size = 'default',
  disabled,
  // if onChange is undefined, the radio is not interactive (i.e. readonly) and renders as a div
  onChange,
  className,
  hasError,
  innerRef,
}) => {
  const state = fromValueToState(value);
  const isInteractive = onChange !== undefined;

  const handleClick = () => {
    onChange?.(!value);
  };

  return isInteractive ? (
    <button
      ref={innerRef as Ref<HTMLButtonElement>}
      type='button'
      className={getRadioClassNames(state, size, disabled, hasError, className)}
      disabled={disabled}
      onClick={handleClick}
      tabIndex={getAccessibleTabIndex(disabled)}
    />
  ) : (
    <div
      ref={innerRef as Ref<HTMLDivElement>}
      className={getRadioClassNames(state, size, disabled, hasError, className)}
    />
  );
};
